
import { getBbsOrderList } from "@/api/order";
import { getBbsOrderServiceList } from "@/api/orderService";
import { UserModule } from "@/store/modules/user";
import { Component, Vue, Prop } from "vue-property-decorator";
import TemplateAddedProgress from "../template/TemplateAddedProgress.vue";

@Component({
  name: "bbsListMessage",
  components: {TemplateAddedProgress},
})
export default class extends Vue {
  private tableData: any = [];
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  private enterType: number = 1;

  created() {
    this.enterType = parseInt(this.$route.query.enterType as string);
    this.getBbsList();
  }

  private getBbsList() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
    };
    if (this.enterType === 1) {
      getBbsOrderList(params).then((res: any) => {
        if(res.data){
          this.pagination.total=res.data.count;
          this.tableData=res.data.list;
        }else{
          this.pagination.total=0;
          this.tableData=[];
        }
      }).catch(err=>{
          this.pagination.total=0;
          this.tableData=[];
      });
    } else {
      getBbsOrderServiceList(params).then((res: any) => {
        if(res.data){
          this.pagination.total=res.data.count;
          this.tableData=res.data.list;
        }else{
          this.pagination.total=0;
          this.tableData=[];
        }
      }).catch(err=>{
          this.pagination.total=0;
          this.tableData=[];
      });
    }
  }

  private handle(bbs:any) {
    if(this.enterType===1){
      let routeData = this.$router.resolve({
      path: '/order/orderToDetail',
      query: {
        order_service_id: bbs.order_service_id,
        orderId: bbs.order_id,
        isCheckOrder: '1',
        showComplaintBtn: '1',
      }
    });
    window.open(routeData.href);
    }else{
      this.$router.push({
      path: '/OrderServicer/todealing',
      query: {
        order_service_id: bbs.order_service_id,
        company_id: UserModule.getCompanyId
      }
    });
    }
  }
  private handlePageSizeChange(size: number) {
    this.pagination.pageSize=size;
    this.getBbsList()
  }
  private handleCurrentChange(size: number) {
     this.pagination.currentPage=size;
    this.getBbsList()
  }
}
